import { View, Text, StyleSheet } from "react-native";
import React, { useEffect } from "react";
import FeedIcons from "../../../assets/Icons/FeedIcons";
import ModalComponent from "../../ModalComponent";

export default function ShowLikeModal({
  isVisible,
  toggleModal,
}: {
  isVisible: any;
  toggleModal: any;
}) {
  useEffect(() => {
    // Close the modal after 1 second
    if (isVisible) {
      const timerId = setTimeout(() => {
        toggleModal();
      }, 400);

      // Clear the timer if the component unmounts or if the modal is closed before the timer expires
      return () => clearTimeout(timerId);
    }
  }, [isVisible, toggleModal]);
  return (
    <ModalComponent isVisible={isVisible} toggleModal={toggleModal}>
      <View style={styles.Container}>
        <View
          style={{
            transform: [{ scale: 2 }],
          }}
        >
          <FeedIcons.LikeIcon />
        </View>
      </View>
    </ModalComponent>
  );
}
const styles = StyleSheet.create({
  Container: {
    flex: 1,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fff",
  },
});
